import NaoLiberado from '@mui/icons-material/Block';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroSituacaoLiberacaoMinutaVoto extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Minuta de voto liberada';
    }

    getIconeFiltroRapido() {
        return <NaoLiberado />;
    }

    filtroRapido = {
        valor: false
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return !!registro.liberadoPeloRelator;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
